import React from "react";
import "../assets/css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../ThemeComponents/Header";
import Footer from "../ThemeComponents/Footer";
import heroImage from "../assets/images/verhuurbedrijven/hero.jpg";
import symbol1 from "../assets/images/verhuurbedrijven/symbol-1.png";
import symbol2 from "../assets/images/verhuurbedrijven/symbol-2.png";
import symbol3 from "../assets/images/verhuurbedrijven/symbol-3.png";
import symbol4 from "../assets/images/verhuurbedrijven/symbol-4.png";
import symbol5 from "../assets/images/verhuurbedrijven/symbol-5.png";
import symbol6 from "../assets/images/verhuurbedrijven/symbol-6.png";
import symbol7 from "../assets/images/verhuurbedrijven/symbol-7.png";

const heroHighlights = [
    "KYC - Rijbewijs check RDW",
    "Onboarding - Persoon checks",
    "Call center - Uw klant snel geholpen",
    "Verhuurpakket - Bespaar tijd en personeelskosten",
    "Inzichten - Biedt uw klant meer service",
    "24/7 - Keyless verhuren mogelijk gemaakt",
    "Verleggen boetes",
    "Afhandelen schade",
];

const benefits = [
    {
        id: "extra-omzet",
        icon: symbol2,
        title: "Extra omzetkanaal zonder extra werk",
        subtitle: "Landelijk bereik, lokaal verhuurd",
        text: [
            "Via KAV2GO wordt landelijk vraag gegenereerd, terwijl het aanbod lokaal blijft. U verhuurt onder uw eigen naam, met uw eigen vloot en tarieven.",
            "Waar Autohopper vooral werkt vanuit een franchiseformule en Oscar zich richt op interne software, combineert KAV2GO beide werelden: zichtbaarheid en operationele ondersteuning."
        ]
    },
    {
        id: "kyc",
        icon: symbol3,
        title: "KYC & onboarding: alleen serieuze huurders",
        subtitle: "Geen verrassingen aan de balie",
        text: [
            "Elke huurder doorloopt vooraf een complete KYC-check. Identiteit, rijbewijs (ook buitenlands), betaling en borg worden vooraf geregeld.",
            "De onboarding is volledig digitaal, waardoor u alleen te maken krijgt met geverifieerde klanten."
        ]
    },
    {
        id: "call-center",
        icon: symbol4,
        title: "Call center: wij nemen het gesprek over",
        subtitle: "U verhuurt, wij communiceren",
        text: [
            "Vragen van huurders? Wij handelen ze af. Reserveringsvragen, wijzigingen en praktische issues worden opgevangen door het KAV2GO call center."
        ]
    },
    {
        id: "pakket",
        icon: symbol5,
        title: "Verhuurpakket dat het hele proces dekt",
        subtitle: "Van boeking tot afrekening",
        text: [
            "Het verhuurpakket stopt niet bij reserveren. Betaling en borg vooraf, automatische verrekening, boeteverlegging en schade-afhandeling inclusief administratie."
        ]
    },
    {
        id: "inzichten",
        icon: symbol6,
        title: "Inzichten die helpen sturen",
        subtitle: "Meer grip op uw vloot",
        text: [
            "U krijgt duidelijke inzichten in bezettingsgraad, opbrengst per voertuig en huurpatronen. Sturen op data in plaats van op gevoel."
        ]
    },
    {
        id: "ervaring",
        icon: symbol7,
        title: "Ontwikkeld door autoverhuurders",
        subtitle: "60 jaar praktijkervaring vertaald naar een platform",
        text: [
            "KAV2GO is een familiebedrijf met ruim 60 jaar ervaring in autoverhuur. Geen theoretisch platform, maar een oplossing die snapt hoe verhuur echt werkt."
        ]
    }
];

const processSteps = [
    {
        id: 1,
        title: "Boeking & screening",
        description: "Klant boekt online, doorloopt KYC en regelt vooraf betaling en borg."
    },
    {
        id: 2,
        title: "24/7 keyless verhuur",
        description: "Voertuig wordt keyless beschikbaar gesteld, zonder extra handelingen op locatie."
    },
    {
        id: 3,
        title: "Service tijdens rit",
        description: "Call center ondersteunt huurder bij vragen, wijzigingen en praktische issues."
    },
    {
        id: 4,
        title: "Automatische afronding",
        description: "Verrekening, boeteverlegging en schade-afhandeling verlopen via het platform."
    }
];

const rentalPageIconColorStyle = {
    filter: "brightness(0) saturate(100%) invert(38%) sepia(82%) saturate(1751%) hue-rotate(202deg) brightness(95%) contrast(92%)"
};

const VoorVerhuurbedrijvenPage = () => {
    return (
        <>
            <Header/>
            <div style={{height: "70px"}}></div>

            <main className="front-rental-company-page">
                <section className="front-rental-company-hero">
                    <div
                        className="front-rental-company-hero__bg"
                        style={{
                            backgroundImage: `linear-gradient(110deg, rgba(var(--wl-heading-rgb), 0.72) 0%, rgba(var(--wl-heading-rgb), 0.54) 42%, rgba(var(--wl-heading-rgb), 0.2) 72%), url(${heroImage})`
                        }}
                    >
                        <div className="container">
                            <div className="front-rental-company-hero__surface">
                                <div className="front-rental-company-hero__content">
                                    <span className="front-rental-company-hero__badge">Voor verhuurbedrijven</span>
                                    <h1>Verhuur uw vloot vrij van debiteurenrisico, opzetschades, verduistering en diefstal</h1>
                                    <p className="front-rental-company-hero__subtitle">
                                        Extra omzetkanaal voor autoverhuurbedrijven
                                    </p>
                                    <ul className="front-rental-company-hero__list">
                                        {heroHighlights.map((item) => (
                                            <li key={item}>
                                                <span><i className="bi bi-check-lg"></i></span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="front-rental-company-intro">
                    <div className="container">
                        <div className="front-rental-company-intro__inner">
                            <img src={symbol1} alt="" aria-hidden="true" style={rentalPageIconColorStyle}/>
                            <div>
                                <h2>Het Mobility Platform</h2>
                                <p className="front-rental-company-intro__lead">Meer verhuur, minder gedoe. Zo simpel is het.</p>
                                <p>
                                    De autoverhuurmarkt verandert snel. Klanten verwachten online boeken, 24/7 beschikbaarheid
                                    en directe duidelijkheid over prijs, borg en voorwaarden. Tegelijkertijd wilt u als verhuurder
                                    vooral doen waar u goed in bent: voertuigen verhuren, niet bezig zijn met administratie,
                                    telefoontjes en discussies achteraf.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="front-rental-company-benefits">
                    <div className="container">
                        <h2 className="front-rental-company-sectionTitle">Waarom dit werkt voor uw verhuurbedrijf</h2>
                        <div className="front-rental-company-benefits__grid">
                            {benefits.map((benefit) => (
                                <article key={benefit.id} className="front-rental-company-benefitCard">
                                    <div className="front-rental-company-benefitCard__iconWrap">
                                        <img src={benefit.icon} alt="" aria-hidden="true" style={rentalPageIconColorStyle}/>
                                    </div>
                                    <h3>{benefit.title}</h3>
                                    <p className="front-rental-company-benefitCard__subtitle">{benefit.subtitle}</p>
                                    {benefit.text.map((paragraph) => (
                                        <p key={paragraph}>{paragraph}</p>
                                    ))}
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="front-rental-company-journey">
                    <div className="container">
                        <h2 className="front-rental-company-sectionTitle">Van boeking tot afrekening</h2>
                        <div className="front-rental-company-journey__grid">
                            {processSteps.map((step) => (
                                <article key={step.id} className="front-rental-company-stepCard">
                                    <span className="front-rental-company-stepCard__number">{step.id}</span>
                                    <h3>{step.title}</h3>
                                    <p>{step.description}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                {/*<section className="front-rental-company-cta">*/}
                {/*    <div className="container">*/}
                {/*        <div className="front-rental-company-cta__inner">*/}
                {/*            <h2>Meer verhuur, minder gedoe</h2>*/}
                {/*            <p>Wilt u zien hoe dit in uw vestiging werkt? Plan een demo met het KAV2GO Mobility team.</p>*/}
                {/*            <div className="front-rental-company-cta__actions">*/}
                {/*                <a href="mailto:info@kav2go.nl?subject=Demo%20aanvraag%20KAV2GO">Plan een demo</a>*/}
                {/*                <a href="tel:0880883434">Bel direct</a>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</section>*/}
            </main>

            <Footer/>
        </>
    );
};

export default VoorVerhuurbedrijvenPage;
